<template>
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center p-4"
    :class="[
      mode === 'dark'
        ? 'bg-white-100 bg-opacity-20'
        : 'bg-black-100 bg-opacity-40',
    ]"
  >
    <div
      class="mx-auto w-full rounded-xl"
      :class="[mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100', width]"
    >
      <div
        v-if="title"
        class="flex items-center justify-between border-b p-5"
        :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
      >
        <h5 class="text-[18px] font-semibold leading-none">
          {{ title }}
        </h5>
        <X
          :size="22"
          :stroke-width="1.75"
          class="cursor-pointer"
          @click="$emit('close')"
        />
      </div>
      <div
        class="without-scrollbar max-h-modal overflow-y-auto rounded-bl-xl rounded-br-xl p-5"
      >
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
import { X } from "lucide-vue-next";

export default {
  name: "Modal",
  props: {
    mode: String,
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "max-w-xl",
    },
  },
  components: {
    X,
  },
};
</script>
